import { PublishedEmptyState } from "./PublishedEmptyState";
import { ScheduledEmptyState } from "./ScheduledEmptyState";

export type PublisherTab = "published" | "scheduled";

export interface SocialPublisherEmptyStateProps {
  tab: PublisherTab;
  onPostVideo: () => void;
}

export const SocialPublisherEmptyState = ({ tab, onPostVideo }: SocialPublisherEmptyStateProps) => {
  if (tab === "published") {
    return <PublishedEmptyState onPostVideo={onPostVideo} />;
  }
  return <ScheduledEmptyState />;
};
